// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"U2-z"};